import './Auth.css';

export default `<div class="signup">
  <h1>Dice App</h1>
  <div id="authRoot"></div>

  <p>Feedback: <a href="mailto:diceapp@owenmead.com">diceapp@owenmead.com</a></p>
</div>`


// WEBPACK FOOTER //
// ./src/Database/Auth.template.html.js